import StatisticsChartComponent from "./StatisticsChartComponent";
import StatisticsKeyValuesComponentQuality from "./StatisticsKeyValuesComponentQuality.js";

const StatisticsQuality = ({
  periodHistoryStart,
  periodHistoryStop,
  periodHistoryStartPrevious,
  periodHistoryStopPrevious,
  enablePreviousPeriod,
  keywordFilter,
  handleValidate,
  setHandleValidate,
  chartCaptureRefs,
  sortingErrorCaptureFlux = null,
}) => {
  return (
    <div className="text-blue w-full flex flex-col gap-6">
      <StatisticsKeyValuesComponentQuality
        periodHistoryStart={periodHistoryStart}
        periodHistoryStop={periodHistoryStop}
        periodHistoryStartPrevious={periodHistoryStartPrevious}
        periodHistoryStopPrevious={periodHistoryStopPrevious}
        enablePreviousPeriod={enablePreviousPeriod}
        keywordFilter={keywordFilter}
        handleValidate={handleValidate}
        setHandleValidate={setHandleValidate}
      />

      <StatisticsChartComponent
        periodHistoryStart={periodHistoryStart}
        periodHistoryStop={periodHistoryStop}
        keywordFilter={keywordFilter}
        handleValidate={handleValidate}
        setHandleValidate={setHandleValidate}
        chartCaptureRefs={chartCaptureRefs}
        sortingErrorCaptureFlux={sortingErrorCaptureFlux}
      />
    </div>
  );
};

export default StatisticsQuality;
